import { Button, Col, Form, notification, Popconfirm, Row } from 'antd';
import { commonApi } from 'api/commonApi';
import { useAppSelector } from 'app/hooks';
import InputField from 'components/Common/InputField/InputField';
import SelectField from 'components/Common/SelectField/SelectField';
import { selectInverterItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import InputTimes from 'components/InputTimes/InputTimes';
import { selectIsDisable } from 'features/Login/authSlice';
import * as React from 'react';
import { customTimeToNumber } from 'utils/common';
import style from './Power.module.scss';
export interface PowerProps {
  inverterConfig: any;
}

export default function Power(props: PowerProps) {
  const { inverterConfig } = props;
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [inputList, setInputList] = React.useState([]);
  const isDisable = useAppSelector(selectIsDisable);
  const inverterId = useAppSelector(selectInverterItemSidebar);

  React.useEffect(() => {
    if (inverterConfig) {
      setInputList(inverterConfig.config.param_list);
    }
  }, [inverterConfig]);

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const handleOk = async (value: any) => {
    try {
      let newList: any = [];
      inputList.map((item: any, index: number) => {
        let newObject;
        if (value[item.key] !== undefined) {
          newObject = {
            key: item.key,
            value: parseFloat(value[item.key]),
          };
        } else {
          newObject = {
            key: item.key,
            value: customTimeToNumber(value['day'], value['hours'], value['minute']),
          };
        }
        newList = [...newList, newObject];
      });
      await commonApi.setValueOfProperties({
        id: inverterId,
        key: 'set-inverter-parameter',
        newList: newList,
      });
      openNotificationWithIcon('success', 'Successfully');
    } catch (error) {
      openNotificationWithIcon('error', 'Failed!');
    }
  };

  const getFields = (inputList: any) => {
    const children: any = [];
    inputList.map((item: any, index: number) => {
      switch (item.input_type) {
        case 'NUMBER':
          return children.push(<InputField key={item.key} item={item} />);
        case 'TIMER':
          return children.push(<InputTimes key={item.key} item={item} />);
        default:
          return children.push(<SelectField key={item.key} item={item} />);
      }
    });
    return children;
  };

  return (
    <Row align="top" className={style.root}>
      <Row className={style.header_info}>
        <Col xxl={{ span: 19 }} lg={{ span: 16 }} className={style.header_label_info}>
          Power control
        </Col>
        <Col xxl={{ span: 5 }} lg={{ span: 8 }} className={style.header_group_btn}>
          {isModalVisible ? (
            <Col
              span={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Button
                onClick={() => {
                  form.resetFields();
                  setIsModalVisible(false);
                }}
                className={style.btn_delete}
              >
                Reset
              </Button>
            </Col>
          ) : (
            <Col
              span={9}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            ></Col>
          )}
          {/* <Col
            span={6}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SwitchField />
          </Col> */}
          <Col
            span={12}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Popconfirm
              disabled={!isModalVisible ? true : false}
              placement="bottomLeft"
              title="Sure to save?"
              onConfirm={() => form.submit()}
            >
              <Button disabled={isDisable} className={style.btn_edit}>
                Save
              </Button>
            </Popconfirm>
          </Col>
        </Col>
      </Row>
      <Row align="top" className={style.main_detail}>
        <Form
          layout="vertical"
          form={form}
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 10,
          }}
          style={{ width: '100%' }}
          hideRequiredMark
          onFinish={handleOk}
          onValuesChange={() => setIsModalVisible(true)}
        >
          {getFields(inputList)}
          {/* <InputTimes /> */}
        </Form>
      </Row>
    </Row>
  );
}
